module.exports = __webpack_public_path__ + "static/media/csa.efc17391.png";